<div class="caisse-wrapper">
  <div *ngIf="displayState !== 'none'" class="caisse">
    <div class="w-100 h-100 d-flex flex-center">
      <span *ngIf="displayState === 'pickNumber'" class="pick-number">{{
        pickNumber
      }}</span>
      <span *ngIf="displayState === 'loading'" class="pick-number">
        <mat-spinner class="white" [diameter]="40"></mat-spinner>
      </span>
      <span *ngIf="displayState === 'novalues'" class="pick-number">
        -&nbsp;-
      </span>
    </div>
  </div>
</div>
